import { Box, ButtonProps } from '@material-ui/core';

import { HeaderContainer } from './style';
import SButton from '../../../../sbutton';
import { SSearchInput } from '../../../ssearch';
import SText from '../../../../sui/stext';
import { TextColor } from '../../../../../enums';

const ActionButton = ({ children, ...props }: ButtonProps) => (
  <SButton
    variant="text"
    size="small"
    style={{ fontWeight: 300, minHeight: '0' }}
    {...props}>
    {children}
  </SButton>
);

export interface SelectMenuHeaderProps {
  title?: string;
  search?: boolean;
  clearButton?: boolean;
  placeholder?: string;
  defaultSearchValue?: string;
  searchValue?: string;
  closeButton?: boolean;
  onClose?: () => void;
  handleClear?: () => void;
  handleChange?: (value: string) => void;
}

const SelectMenuHeader = ({
  title,
  search = true,
  clearButton = false,
  closeButton = false,
  placeholder,
  defaultSearchValue,
  searchValue,
  onClose,
  handleClear,
  handleChange
}: SelectMenuHeaderProps) => (
  <Box width="100%">
    <HeaderContainer>
      {Boolean(title) && (
        <SText title={title} weight="bold" fontColor={TextColor.Black} />
      )}
      {clearButton && handleClear && (
        <ActionButton onClick={handleClear}>Clear</ActionButton>
      )}
      {!clearButton && closeButton && onClose && (
        <ActionButton onClick={onClose}>Close</ActionButton>
      )}
    </HeaderContainer>
    {search && handleChange && (
      <Box mt={2} mb={2}>
        <SSearchInput
          width="100%"
          searchedValue={searchValue}
          defaultValue={defaultSearchValue}
          placeholder={placeholder}
          onChange={handleChange}
          style={{ width: '100%' }}
        />
      </Box>
    )}
  </Box>
);

export default SelectMenuHeader;
